import React, {Fragment, useEffect, useMemo, useState} from 'react'
import {useQueries, useQuery} from 'react-query'
import {useHistory, useParams} from 'react-router-dom'
import {getSegmentAggregations, getSubsegments} from '../../api'
import {useAppDispatch} from '../../Contexts/AppContext'
import {toServerDatetimeFormat} from '../../Utils/dates'
import LoadingValue from '../../components/LoadingValue'
import SearchInput from '../../components/SearchInput'
import BasicTable from '../../components/BasicTable'
import {useSegmentState} from '../../Contexts/SegmentContext'
import SubSegmentsPageActions from './SubSegmentsPageActions'
import AudienceHeader from '../../components/AudienceHeader'
import {useTranslation} from "react-i18next";

const SubSegmentsPage = () => {
    const { t } = useTranslation();
    const {segmentId} = useParams()
    const {segment, segmentRequest} = useSegmentState()
    const [list, setList] = useState([])
    const [pagination, setPagination] = useState(null)
    const [search, setSearch] = useState('')
    const [sorting, setSorting] = useState([])
    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(15)
    const history = useHistory()
    const {setBreadcrumbs, setSection} = useAppDispatch()
    const [selectedRows, setSelectedRows] = useState([])
    const tableColumns = useMemo(() => {
        return [
            {
                Header: t('segments page.segments name'),
                accessor: 'name'
            },
            {
                Header: t('segments page.created date'),
                accessor: 'created_at',
                Cell: ({value}) => toServerDatetimeFormat(value)
            },
            {
                Header: t('segments page.leads'),
                accessor: 'leads_count',
                disableSortBy: true,
                Cell: ({value}) => <LoadingValue value={value}/>
            },
            // {
            //     Header: 'Duplicates',
            //     accessor: 'duplicates_count',
            //     disableSortBy: true,
            //     Cell: ({value}) => <LoadingValue value={value}/>
            // },
            // {
            //     Header: t('segments page.status'),
            //     accessor: 'status',
            //     disableSortBy: true,
            //     className: 'text-right',
            //     Cell: ({value}) => (
            //         <div className="chipLike success">
            //             <span className="chipLikeLabel">Active</span>
            //         </div>
            //     )
            // }
        ]
    }, [t])
    const tableData = useMemo(() => {
        return list.map(item => {
            return {...item, status: true}
        })
    }, [list])

    const subsegmentsRequest = useQuery(
        ['subsegmentsList', segmentId, page, limit, search, sorting],
        () => getSubsegments(segmentId, page, limit, search, sorting),
        {keepPreviousData: true}
    )

    useEffect(() => {
        if (subsegmentsRequest.isSuccess) {
            setList(subsegmentsRequest.data.data)
            setPagination(subsegmentsRequest.data.meta)
        }
    }, [
        subsegmentsRequest.isSuccess,
        subsegmentsRequest.data
    ])

    const segmentAggregationsRequests = useQueries(list.map(segment => {
        return {
            queryKey: ['segmentAggregations', segment.id],
            queryFn: () => getSegmentAggregations(segment.id),
            cacheTime: 1000 * 300,
            refetchOnMount: false
        }
    }))

    useEffect(() => {
        segmentAggregationsRequests.forEach(req => {
            if (req.isSuccess) {
                setList(prev => {
                    const updatedSegment = req.data.data;
                    const newList = [...prev]
                    const index = newList.findIndex(s => s.id === updatedSegment.id)
                    if (index !== -1) {
                        newList[index] = {
                            ...newList[index],
                            leads_count: updatedSegment.leads_count,
                            duplicates_count: updatedSegment.duplicates_count,
                        }
                    }
                    return newList
                })
            }
        })
    }, [segmentAggregationsRequests])

    useEffect(() => {
        setBreadcrumbs([
            {label: t('main menu.audiences'), link: '/'},
            {
                label: segment && segment.name,
                link: `/audiences/${segment?.id}/leads`,
                loading: subsegmentsRequest.isLoading
            },
            {
                label: t('segments page.segments')
            }
        ])
        setSection('segments')
    }, [setBreadcrumbs, setSection, segment, subsegmentsRequest.isLoading, t])

    useEffect(() => {
        setPage(1)
    }, [search])

    const handleItemClick = item => {
        history.push(`/audiences/${segment?.id}/segments/${item.id}`)
    }

    const renderSearchBlock = () => {
        return (
            <div className="searchHolder mb30">
                <div className="inputHolder">
                    <SearchInput
                        search={search}
                        onChange={s => setSearch(s)}
                    />
                </div>
            </div>
        )
    }

    return (
        <Fragment>
            <div className="pageTableBlock">
                {renderSearchBlock()}
                <AudienceHeader />
                <div className="tableHolder hasCheckboxes rowClickable">
                    <BasicTable
                        columns={tableColumns}
                        data={tableData}
                        loading={subsegmentsRequest.isLoading}
                        fetching={subsegmentsRequest.isFetching}
                        isSelectionColumn={true}
                        onSelectedRows={setSelectedRows}
                        onRowClick={handleItemClick}
                        onSort={setSorting}
                        emptyDataText={t('segment leads page actions.No Segments Found')}
                        pagination={pagination}
                        pageLimit={limit}
                        onPageChange={setPage}
                        onLimitChange={(l) => {
                            setPage(1)
                            setLimit(l)
                        }}
                    />
                    <SubSegmentsPageActions
                        segment={segment}
                        loading={segmentRequest.isLoading}
                        search={search}
                        sorting={sorting}
                        selectedRows={selectedRows}
                        // visibleColumns={visibleColumns}
                    />
                </div>
            </div>
        </Fragment>

    )
}

export default SubSegmentsPage
